import { useRef, useEffect, type FC, type ReactNode } from 'react';

interface TransitionProps {
  children: ReactNode;
  type: string;
  in: boolean;
  timeout: number;
}

const Transition: FC<TransitionProps> = ({ children, type, in: inProp, timeout }) => {
  const nodeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (nodeRef.current) {
      if (inProp) {
        nodeRef.current.classList.add(`${type}-enter`);
        setTimeout(() => {
          nodeRef.current?.classList.remove(`${type}-enter`);
          nodeRef.current?.classList.add(`${type}-enter-active`);
        }, 10);
      } else {
        nodeRef.current.classList.add(`${type}-exit`);
        setTimeout(() => {
          nodeRef.current?.classList.remove(`${type}-exit`);
          nodeRef.current?.classList.add(`${type}-exit-active`);
        }, 10);
      }
    }
  }, [inProp, type, timeout]);

  return (
    <div ref={nodeRef} className={`${type}-base`}>
      {children}
    </div>
  );
};

export default Transition;
